import { Component, OnInit } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';
import { tap } from 'rxjs/operators';
import { AllegatiService } from 'src/app/core/allegati.service';
import { DocumentiService } from 'src/app/core/documenti.service';
import { DocumentiListColumnNames } from 'src/app/shared/components/documenti-list/documenti-list.model';
import { DistruzioneAllegato } from 'src/app/shared/models/DistruzioneRequest.model';
import { DocumentiSearchDocRow, DocumentiSearchRequest, DocumentiSearchResponse } from 'src/app/shared/models/documento-search.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-classifiche-in-scadenza',
  templateUrl: './classifiche-in-scadenza.component.html',
  styleUrls: ['./classifiche-in-scadenza.component.scss']
})
export class ClassificheInScadenzaComponent implements OnInit {



  public states: { label: string, value: number }[] = [
    { label: 'In scadenza', value: 1 },
    { label: 'Scaduti', value: 2 },
  ];

  public selectedState = 1;
  public columns: DocumentiListColumnNames = ['PosizioneId', 'Protocollo', 'DataDocumento', 'Oggetto', 'DataScadenzaClassifica', 'ActionButtons'];

  public searchResponse = { originalRequest: { pageFirstRow: 0, pageSize: 0, sortField: 'DataDocumento', sortOrder: 1 } } as DocumentiSearchResponse;
  public showDeclassificaDialog = false;
  public showDistruzioneDialog = false;
  public currDocumentId = -1;
  public currDocumentoDistruzioneAllegati: DistruzioneAllegato[] = [];
  public selectProtocollo: string[] = [];
  public protocolloList: string[] = [];
  public selectedProtocol = '';
  public qualificaSelected: number | null = null;
  public classificaSelected: number | null = null;
  private showAll = 'Mostra tutti i protocolli';

  constructor(private documentiService: DocumentiService, private allegatiService: AllegatiService) { }

  ngOnInit(): void {
    this.search();
  }

  changeViewState(newViewState: SelectButtonChangeEvent): void {
    if (newViewState.value === 2) {
      this.searchResponse.originalRequest.pageSize = 50;
    } else {
      this.searchResponse.originalRequest.pageSize = 0;
    }
    this.protocolloList = [];
    this.selectedProtocol = '';
    this.search();
  }

  search(searchByProtocol?: string): void {
    const request = {
      pageFirstRow: 0,
      filters: {}
    } as DocumentiSearchRequest;

    request.filters.statoScadenza = this.selectedState;
    request.filters.expirationDaysLimit = environment.daysLimit.toTableList;
    request.filters.untilExpirationAlert = environment.daysLimit.untilExpirationAlert;
    request.filters.excludeDestroyed = true;
    request.sortField = 'DataScadenzaClassifica';
    request.sortOrder = 1;

    if (searchByProtocol && searchByProtocol !== this.showAll) {
      request.filters.protocollo = searchByProtocol;
    }
    this.updateRequestAndSearch(request);
  }


  updateRequestAndSearch(request: DocumentiSearchRequest | null): void {
    const mergedRequest = { ...this.searchResponse.originalRequest, ...request };
    this.documentiService.search(mergedRequest).pipe(
      tap(response => {
        this.searchResponse = response;
        if (this.protocolloList.length <= 1) {
          this.protocolloList = [
            this.showAll,
            ...Array.from(new Set(this.searchResponse.results.map<string>(d => (d.data as DocumentiSearchDocRow).protocollo)))
          ];
        }

      }),
    ).subscribe();
  }

  onShowDeclassifica(document: DocumentiSearchDocRow): void {
    this.showDeclassificaDialog = true;
    this.currDocumentId = document.documentoId;
    this.qualificaSelected = document.qualificaId ?? null;
    this.classificaSelected = document.classificaId ?? null;
  }

  onHideDeclassifica(): void {
    this.showDeclassificaDialog = false;
    this.currDocumentId = -1;
    this.qualificaSelected = null;
    this.classificaSelected = null;
  }

  onShowDistruzione(document: DocumentiSearchDocRow): void {
    this.allegatiService.getAllegati(document.documentoId).subscribe(allegati => {
      this.currDocumentoDistruzioneAllegati = allegati.map(el => ({ allegatoId: el.streamId, pagine: null, fileName: el.fileName }));
      this.showDistruzioneDialog = true;
      this.currDocumentId = document.documentoId;
    });
  }

  onHideDistruzione(): void {
    this.showDistruzioneDialog = false;
    this.currDocumentId = -1;
    this.currDocumentoDistruzioneAllegati = [];
  }

  filterTableResults(): void {
    this.search(this.selectedProtocol);
  }

  protocolloSearch(ev: AutoCompleteCompleteEvent): void {
    const filteredList = [...this.protocolloList];
    this.selectProtocollo = [...filteredList.filter(p => p.split('/')[0].toLowerCase().indexOf(ev.query.toLowerCase()) !== -1)];
  }

  filterKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.filterTableResults();
    }
  }

  focusAutocomplete(event: Event): void {
    (event.target as HTMLInputElement).select();
  }

}
